<template>
  <li class="activity__card-item">
    <LangRouterLink :to="activity.route" class="activity__card" :title="activity.title">
      <Image :source="activity.image" class="activity__card-image" />
      <div class="activity__card-content">
        <p :class="['activity__card-category', color(category.color, 'activity')]">
          {{ details(activity) }}
        </p>
        <h3 class="small-title --arrow">
          <span>{{ activity.title }}</span>
          <Icon id="arrow" />
        </h3>
        <p>{{ activity.short_description }}</p>
      </div>
    </LangRouterLink>
  </li>
</template>

<script>
import { Icon, Image, LangRouterLink } from '@/components/global'
import { color, details } from '@/helpers'
import { HasCategory } from '@/mixins'

export default {
  name: 'ActivityCard',
  mixins: [HasCategory],
  props: {
    activity: {
      type: Object,
      required: true,
    },
  },
  components: { Icon, Image, LangRouterLink },
  computed: {
    category() {
      return this.getCategory(this.activity.category) ?? { color: 'pp' }
    },
  },
  methods: { color, details },
}
</script>
